import React, { useState } from 'react';

// Sección plegable de la pantalla; arranca abierta.
export default function Seccion({ titulo, total, children }) {
  const [abierta, setAbierta] = useState(true);
  return (
    <section className="ap-seccion">
      <h3>
        <button type="button" className="ap-seccion-titulo" aria-expanded={abierta} onClick={() => setAbierta((a) => !a)}>
          <span aria-hidden="true">{abierta ? '▾' : '▸'}</span> {titulo}
          {total != null && <span className="chip chip-muted">{total}</span>}
        </button>
      </h3>
      {abierta && <div className="ap-seccion-cuerpo">{children}</div>}
    </section>
  );
}
